import { useIsWoopDemoMode } from 'features/workload-optimization';
import {
  UseWorkloadRecommendationManifestQueryArgs,
  useWorkloadRecommendationManifestQuery,
} from 'hooks/queries/workload-optimization';

export const useWoopWorkloadRecommendationManifest = (
  queryArgs: UseWorkloadRecommendationManifestQueryArgs
) => {
  const isWoopDemoMode = useIsWoopDemoMode();

  const queryResult = useWorkloadRecommendationManifestQuery({
    ...queryArgs,
    enabled: !isWoopDemoMode && queryArgs.enabled,
  });

  return queryResult;
};
